<app-home-manager *ngIf="isManager"></app-home-manager>
<app-home-realtor *ngIf="!isManager"></app-home-realtor>